/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_PasteInputs */

const en_editor_paste = /** @type {(inputs: Editor_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste as text`)
};

const de_editor_paste = /** @type {(inputs: Editor_PasteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Text einfügen`)
};

/**
* | output |
* | --- |
* | "Paste as text" |
*
* @param {Editor_PasteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_paste = /** @type {((inputs?: Editor_PasteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_PasteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_paste(inputs)
	return en_editor_paste(inputs)
});